import type { IconSvgObject } from './types';

const DatevIcon: IconSvgObject = [
  ["path", { d: "M1.25 14.5V9.5H2.25C3.63071 9.5 4.75 10.6193 4.75 12C4.75 13.3807 3.63071 14.5 2.25 14.5H1.25Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ["path", { d: "M5.75 14.5L7.75 9.5L9.75 14.5H8.03571", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ["path", { d: "M18.75 9.5L20.75 14.5L22.75 9.5H21.0357", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ["path", { d: "M10.25 9.5H11.75M13.25 9.5H11.75M11.75 9.5V14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ["path", { d: "M17.25 14.5H14.75V12M17.25 9.5H14.75V12M14.75 12H17.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", key: "4" }]
];

export default DatevIcon;
